<template>
  <img
    :title="title"
    :src="src"
    :srcset="srcset"
    :class="{ flipped: isFlipped }"
    @click="handleClick"
  />
</template>

<script>
export default {
  name: "FlippingMultiImage",
  props: {
    name: String,
    title: String,
  },
  data: () => {
    return {
      isFlipped: false,
    };
  },
  computed: {
    src() {
      return this.$store.getters[this.name].src;
    },
    srcset() {
      return this.$store.getters[this.name].srcset;
    },
  },
  methods: {
    handleClick: function() {
      this.isFlipped = !this.isFlipped;
      this.$emit("click");
    },
  },
};
</script>

<style scoped lang="scss">
.flipped {
  -webkit-transform: scaleY(-1);
  transform: scaleY(-1);
}
</style>
